<form [formGroup]="generatedform" [showHideAnimation]="form" class="background">
  <h4>{{ form.title }}</h4>
  <gstar-template-factory />
</form>
